import type {
    BlockedDomainDto,
    BlockedDomainsPageDto,
    BlockedSourceDto,
    BlockedSourcesPageDto,
} from './dto';
import type { BlockedDomain, BlockedSource, BlocksPage } from './types';

function str(value: string | null | undefined): string | null {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === 'None') return null;
    return trimmed;
}

function toDate(value: string | null | undefined): Date | null {
    const raw = str(value);
    if (raw === null) return null;
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Домен из адреса: у части записей поле domain пустое. */
function hostFromUrl(url: string | null): string {
    const raw = str(url);
    if (raw === null) return '—';
    try {
        return new URL(raw).hostname.toLowerCase().replace(/^www\./, '');
    } catch {
        return raw;
    }
}

export function toBlockedDomain(dto: BlockedDomainDto): BlockedDomain {
    const url = str(dto.original_link) ?? str(dto.name) ?? '';
    return {
        id: dto.id,
        domain: str(dto.domain) ?? hostFromUrl(url),
        url,
        author: str(dto.author) ?? '—',
        createdAt: toDate(dto.created_at),
        reason: str(dto.reason) ?? 'Причина не указана',
    };
}

/** project_url приходит абсолютным на боевой домен — берём из него только id. */
function projectIdFromUrl(url: string | null): string | null {
    const raw = str(url);
    if (raw === null) return null;
    const match = raw.match(/\/projects\/([^/?#]+)/);
    return match?.[1] ?? null;
}

export function toBlockedSource(dto: BlockedSourceDto, index: number): BlockedSource {
    const fullUrl = str(dto.full_url) ?? '';
    return {
        /* Собственного id у записи нет: адрес плюс время блокировки уникальны,
           индекс — страховка на случай полного совпадения. */
        key: `${fullUrl}|${dto.blocked_at ?? ''}|${index}`,
        host: str(dto.url_host) ?? hostFromUrl(fullUrl),
        fullUrl,
        productName: str(dto.product_name_optimized) ?? str(dto.product_name) ?? '—',
        projectName: str(dto.project_name) ?? '—',
        projectId: projectIdFromUrl(dto.project_url),
        sourceTitle: str(dto.source_title) ?? '—',
        blockedAt: toDate(dto.blocked_at),
        reason: str(dto.blocking_reason) ?? 'Причина не указана',
        blockedBy: str(dto.user_blocked) ?? '—',
    };
}

export function toBlockedDomainsPage(dto: BlockedDomainsPageDto): BlocksPage<BlockedDomain> {
    return {
        items: Array.isArray(dto?.data) ? dto.data.map(toBlockedDomain) : [],
        total: dto?.count ?? 0,
        pages: dto?.pages ?? 1,
        pageNum: dto?.page_num ?? 1,
    };
}

export function toBlockedSourcesPage(dto: BlockedSourcesPageDto): BlocksPage<BlockedSource> {
    return {
        items: Array.isArray(dto?.blocked_hosts_info) ? dto.blocked_hosts_info.map(toBlockedSource) : [],
        total: dto?.count ?? 0,
        pages: dto?.pages ?? 1,
        pageNum: dto?.page_num ?? 1,
    };
}